import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 4l5 9l5 -9","key":"svg-0"}],["path",{"d":"M12 13l0 7","key":"svg-1"}]]

const IconLetterY = createReactComponent('outline', 'letter-y', 'LetterY', __iconNode);

export default IconLetterY;